import { useAuth } from '../../contexts/AuthContext/AuthContext'

export default function Dashboard() {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    return (
      <div>
        <h1>Authentication Required</h1>
        <p>Please log in to access the dashboard.</p>
      </div>
    )
  }

  return (
    <>
      <h1 className="font-display text-3xl font-semibold text-slate-900">Dashboard</h1>
      <p className="text-slate-600">Welcome to your dashboard!</p>
    </>
  )
} 